import React from 'react';
import { useCadrageBlockers } from '../../../hooks/useCadrageBlockers'; // Importer le hook
import BlockerManager from '../BlockerManager'; // Importer le composant manager

interface CadrageBlockersSectionProps {
  cadrageId: string | undefined; // ID nécessaire pour le hook
  isReadOnly?: boolean; // Mode lecture seule
}

const CadrageBlockersSection: React.FC<CadrageBlockersSectionProps> = ({
  cadrageId,
  isReadOnly = false,
}) => {
  // Utiliser le hook pour obtenir les données et les fonctions CRUD
  const {
    blockers,
    isLoading,
    error,
    addBlocker,
    updateBlocker,
    deleteBlocker,
    // refreshBlockers, // Pas utilisé directement ici, mais disponible
  } = useCadrageBlockers(cadrageId);

  // Le composant BlockerManager gère l'affichage et l'interaction (modale)
  // Il suffit de lui passer les données et les fonctions du hook
  return (
    <BlockerManager
      cadrageId={cadrageId || ''} // Passer l'ID (ou chaîne vide si undefined)
      blockers={blockers}
      isLoading={isLoading}
      error={error}
      addBlocker={addBlocker}
      updateBlocker={updateBlocker}
      deleteBlocker={deleteBlocker}
      isReadOnly={isReadOnly}
    />
  );
};

export default CadrageBlockersSection;
